// Function to use variables
export function useVariable(placeholder, template, setTemplate, setTemplateVariable){
    let pattern = /(?:^|\s)\{\{(?!\S)/;
    setTemplate({...template, content: template.content.replace(pattern, ` ${placeholder}`)})
    setTemplateVariable(false)
  }

  // Function to use variables
export function useTitleVariable(placeholder, template, setTemplate, setTitleVariable){
  let pattern = /(?:^|\s)\{\{(?!\S)/
  setTemplate({...template, title: template.title.replace(pattern, ` ${placeholder}`)})
  setTitleVariable(false)
}

//   Function to get the post or template owner type
  export function getOwnerType(placeholder, setTemplateOwnerType, users){
    for (let x = 0; x < users.length ; x++) {
      let current = users[x]
      if (current.id == placeholder.user_id) {
        setTemplateOwnerType(current.user_type)
      }
    }
  }

//   Function to detect template variables
  export function detectTemplateVariables(template, setTemplateVariable){
    let pattern = /(?:^|\s)\{\{(?!\S)/
    if (pattern.test(template.content)) {
      setTemplateVariable(true)
    } else {
      setTemplateVariable(false)
    }
  }

  //   Function to detect template variables
  export function detectTitleVariables(template, setTitleVariable){
    let pattern = /(?:^|\s)\{\{(?!\S)/
    if (pattern.test(template.title)) {
      setTitleVariable(true)
    } else {
      setTitleVariable(false)
    }
  }

//   Function to get all donor fields and custom fields
  export function getDonorFields(users, donorFields){
    for (let x = 0; x < users.length; x++) {
      let current = users[x]
      if (current.user_type == "donor") {
        current.team_custom_fields.map(fields => {
          donorFields.push(fields.name.replace(' ', '_').toLowerCase())
        })
        break;
      }
    }
  }

//   Function to get all beneficiary fields and custom fields
 export function getBeneficiaryFields(users, beneficiaryFields){
    for (let x = 0; x < users.length; x++) {
      let current = users[x]
      if (current.user_type == "beneficiary") {
        current.team_custom_fields.map(fields => {
          beneficiaryFields.push(fields.name.replace(' ', '_').toLowerCase())
        })
        break;
      }
    }
  }